// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Like_wrapper__2RGwx"};